module.exports = __webpack_public_path__ + "img/jpg01_fwsxq.cb88a8c7.png";